import { mergeSharedTranslations } from "@shared/utils/mergeSharedTranslations";

import { common } from "./common";
import { error } from "./error";
import { intake } from "./intake";
import { journeyCheckout } from "./journeyCheckout";
import { linkNotification } from "./linkNotification";
import { multiplatformNotification } from "./multiplatformNotification";
import { officeSignUp } from "./officeSignUp";
import { patientRxAuth } from "./patientRxAuth";
import { practitionerSignUp } from "./practitionerSignUp";
import { regionSelector } from "./regionSelector";
import { signIn } from "./signIn";
import { UH } from "./UH";

export const US = mergeSharedTranslations({
  common,
  error,
  officeSignUp,
  patientRxAuth,
  practitionerSignUp,
  linkNotification,
  multiplatformNotification,
  regionSelector,
  signIn,
  intake,
  journeyCheckout,
  UH,
  emerson: {
    header: {
      Title: "Emerson Ecologics",
    },
  },
});
